/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const headerActionsStyle = {
  loginButton: {
    flexGrow: 1,
    boxShadow: "none",
    "&:hover, &:focus-visible": {
      boxShadow: "none",
    },
  },
};
